import { HttpError, isNetworkError } from '@littlebird/auth-client';

/** True when resending the same batch can succeed: network errors, 5xx, 408, or 429. */
export function isTransientTranscriptSyncError(error: unknown): boolean {
  if (error instanceof HttpError) {
    return error.status >= 500 || error.status === 408 || error.status === 429;
  }
  return isNetworkError(error);
}
